import type { OfflineOperation } from './types';

export interface SyncResult {
  operation_id: string;
  status: string;
  error?: string;
  result?: Record<string, unknown>;
  duplicate?: boolean;
}

// Older servers wrap persisted duplicate results in {data: ...} / {error: ...}.
export function normalizeSyncResult(result: SyncResult): SyncResult {
  const stored = result.result;
  return {
    ...result,
    error: result.error || (typeof stored?.error === 'string' ? stored.error : undefined),
    result: result.duplicate && stored && 'data' in stored
      ? stored.data as Record<string, unknown> | undefined : stored,
  };
}

export function applySyncResults(operations: OfflineOperation[], results: SyncResult[]): OfflineOperation[] {
  const byID = new Map(results.map(result => [result.operation_id, normalizeSyncResult(result)]));
  return operations.flatMap(operation => {
    const result = byID.get(operation.operation_id);
    if (!result) return [operation];
    if (result.status === 'accepted') return [];
    return [{ ...operation, status: 'error' as const, error: result.error || 'Der Server hat den Vorgang nicht bestätigt. Bitte erneut synchronisieren.' }];
  });
}

export function operationLabel(action: string): string {
  return ({ clock_in: 'Arbeitsbeginn', clock_out: 'Arbeitsende', break_start: 'Pausenbeginn', break_end: 'Pausenende', absence_request: 'Abwesenheitsantrag', time_change_request: 'Zeitänderung', submit_time_day: 'Arbeitstag einreichen', report_create: 'Bericht anlegen', report_update: 'Bericht ändern', report_submit: 'Bericht einreichen' } as Record<string, string>)[action] || action;
}
